<div class="subheader">
    <div
        [ngClass]="isMobile
            ? 'container_ d-flex flex-wrap flex-column'
            : 'container_ d-flex align-items-center justify-content-between flex-wrap'
        "
    >
        <h1>{{subheader}}</h1>
        <ng-content></ng-content>
    </div>
</div>
